import { API_IAM } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function getDrugs(params) {
  return {
    types: [
      ACTION_TYPES.PRESCRIPTION_GET_DRUGS_REQUESTED,
      ACTION_TYPES.PRESCRIPTION_GET_DRUGS_SUCCESS,
      ACTION_TYPES.PRESCRIPTION_GET_DRUGS_FAILED,
    ],
    promise: client =>
      client.get(`/proxies/drugs`, {
        params,
      }),
    options: {
      clientName: API_IAM,
    },
  };
}
